/**
 * Canonical origin for the public site. Used for `<link rel="canonical">`,
 * `og:url`, absolute social-image URLs, and the Organization JSON-LD in the
 * root document. Override per environment with `VITE_PUBLIC_SITE_URL` (no
 * trailing slash); the static `robots.txt` and `sitemap.xml` in `public/`
 * hardcode the same production origin.
 */
export const SITE_URL =
	import.meta.env.VITE_PUBLIC_SITE_URL ?? 'https://sealedger.app'

export function absoluteUrl(path: string) {
	return new URL(path, SITE_URL).toString()
}
